import { Card, CardBody, CardHeader } from "reactstrap";
import { useAccess } from "../../../utils/hooks/access";
import { useUser } from "../../../utils/hooks/user";
import { useConfigInitialFilters } from "../../Settings/Configuration/hooks/useConfigInitialFilters";
import Topbar from "../components/Topbar";
import { OverviewProvider } from "../components/Topbar/context";
import ConfigurationLoader from "../configurationLoader";
import { FiltersProvider } from "../filtersContext";
import { DateFiltersProvider } from "../hooks/useDateFilters";
import { PayCodesProvider } from "../reusedResourcesContext";
import Content from "./Content";
import Weekly from "./Weekly";

const Home = () => {
    const initialFilters = useConfigInitialFilters("myTimesheet", "hourType");
    const { hasAccess: canViewRates } = useAccess("canViewMyRates");

    const user = useUser();
    if (user.calculationGroup?.timesheetMethod === "weekly") {
        return <Weekly />;
    }

    return (
        <PayCodesProvider>
            <ConfigurationLoader>
                <FiltersProvider
                    sessionKey="TIMESHEET_HOME_FILTERS"
                    initialValue={initialFilters}
                >
                    <DateFiltersProvider>
                        <OverviewProvider>
                            <Card className="time-sheet px-0 m-0 h-100 position-static">
                                <CardHeader>
                                    <Topbar page="home" canViewRates={canViewRates} />
                                </CardHeader>

                                <CardBody className="p-0 d-flex flex-column">
                                    <Content />
                                </CardBody>
                            </Card>
                        </OverviewProvider>
                    </DateFiltersProvider>
                </FiltersProvider>
            </ConfigurationLoader>
        </PayCodesProvider>
    );
};

export default Home;
